// Sidebar Routers
export const employeeMenus = {
    "lang.general": [
        { action: "space_dashboard", title: "lang.dashboard", active: false, path: "/dashboard", name: "dashboard", exact: true },
        { action: "contacts", title: "lang.customers", path: "/customers", name: "customers", exact: true, module: "companies", permission: "companies.read" },
        { action: "dock", title: "lang.devices", path: "/devices", name: "devices", exact: true, permission: "devices.read" },
        { action: "sell", title: "lang.device_tags", path: "/tags", exact: true, icon_class: "material-icons-outlined", permission: "tags.read" },
        {
            action: "attach_money",
            title: "lang.orders",
            path: "/orders",
            exact: true,
            permission: "transaction_documents.read",
            module: "transaction_documents",
        },
        { action: "people", title: "lang.people", path: "/people", name: "people", exact: true, module: "people", permission: "people.read" },
        {
            action: "local_shipping",
            title: "lang.shipments",
            path: "/shipment_planners",
            name: "shipment_planners",
            exact: true,
            module: "shipment_planners",
            permission: "shipment_planners.read",
        },
        { action: "autorenew", title: "lang.subscriptions", path: "/subscriptions", exact: true, permission: "subscriptions.read" },
        { action: "propane_tank", title: "lang.tanker_trucks", path: "/tanker_trucks", exact: true, permission: "tanker_trucks.read" },
        { action: "category", title: "lang.tank_products", path: "/tank_products", exact: true, permission: "products.read" },
        { action: "inventory_2", title: "lang.work_orders", active: false, items: null, path: "/work_orders", exact: true, permission: "work_orders.read" },
        { action: "troubleshoot", title: "lang.techhelp", active: false, items: null, path: "/techhelp", exact: true },
    ],
};

export const customerMenus = {
    "lang.general": [
        { action: "space_dashboard", title: "lang.dashboard", active: false, path: "/dashboard", name: "dashboard", exact: true },
        { action: "dock", title: "lang.devices", path: "/devices", exact: true, permission: "devices.read" },
        { action: "sell", title: "lang.device_tags", path: "/tags", exact: true, icon_class: "material-icons-outlined", permission: "tags.read" },
        { action: "people", title: "lang.people", path: "/people", exact: true, permission: "people.read" },
        {
            action: "local_shipping",
            title: "lang.shipments",
            path: "/shipment_planners",
            name: "shipment_planners",
            exact: true,
            module: "shipment_planners",
            permission: "shipment_planners.read",
        },

        { action: "category", title: "lang.tank_products", path: "/tank_products", exact: true, permission: "products.read" },
        { action: "troubleshoot", title: "lang.techhelp", active: false, items: null, path: "/techhelp", exact: true },
    ],
};
export const distributorMenus = {
    "lang.general": [
        { action: "space_dashboard", title: "lang.dashboard", active: false, path: "/dashboard", name: "dashboard", exact: true },
        { action: "contacts", title: "lang.customers", path: "/customers", name: "customers", exact: true, module: "companies" },
        { action: "dock", title: "lang.devices", path: "/devices", exact: true, permission: "devices.read" },
        { action: "sell", title: "lang.device_tags", path: "/tags", exact: true, icon_class: "material-icons-outlined", permission: "tags.read" },
        { action: "people", title: "lang.people", path: "/people", exact: true, permission: "people.read" },
        {
            action: "local_shipping",
            title: "lang.shipments",
            path: "/shipment_planners",
            name: "shipment_planners",
            exact: true,
            module: "shipment_planners",
            permission: "shipment_planners.read",
        },

        { action: "category", title: "lang.tank_products", path: "/tank_products", exact: true, permission: "products.read" },
        { action: "inventory_2", title: "lang.work_orders", active: false, items: null, path: "/work_orders", exact: true, permission: "work_orders.read" },
        { action: "troubleshoot", title: "lang.techhelp", active: false, items: null, path: "/techhelp", exact: true },
    ],
};

export const menu = {};
